/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import GetStartedPage from '../../pages/client/GetStartedPage/GetStartedPage';
import WelcomePage from '../../pages/client/WelcomePage/WelcomePage';
// import TradesPage from '../../pages/client/TradesPage/TradesPage';
import FinancesPage from '../../pages/client/FinancesPage/FinancesPage';
import W9UploadPage from '../../pages/client/W9UploadPage/W9UploadPage';
import YourCompanyPage from '../../pages/client/YourCompanyPage/YourCompanyPage';
// import YourTeamPage from '../../pages/client/YourTeamPage/YourTeamPage';
// import ServiceAreaPage from '../../pages/client/ServiceAreaPage/ServiceAreaPage';
// import DocumentsPage from '../../pages/client/DocumentsPage/DocumentsPage';
// import FileUploadPage from '../../pages/client/FileUploadPage/FileUploadPage';
import RegistrationCompletePage from '../../pages/client/RegistrationCompletePage/RegistrationCompletePage';

export default function ClientNavigation() {
    return (
            <Routes>
                <Route path='welcome' element={<WelcomePage/>} />
                <Route path='welcome/retail' element={<WelcomePage/>} />
                <Route path='getstarted' element={<GetStartedPage/>} />
                {/*<Route path='/client/trades' component={TradesPage} />*/}
                <Route path='company' element={<YourCompanyPage/>} />
                <Route path='finances' element={<FinancesPage/>} />
                <Route path='w9' element={<W9UploadPage/>} />
                {/*<Route path='/client/team' component={YourTeamPage} />*/}
                {/*<Route path='/client/service' component={ServiceAreaPage} />*/}
                {/*<Route path='/client/documents' component={DocumentsPage} />*/}
                {/*<Route*/}
                {/*    path='/client/upload/:fileName/:label'*/}
                {/*    component={FileUploadPage}*/}
                {/*/>*/}
                <Route
                    path='complete'
                    element={<RegistrationCompletePage/>}
                />
                <Route path="*" element={<Navigate to='welcome' replace/>}/>
            </Routes>
    );
}
